import * as tslib_1 from "tslib";
import { Logger, } from '@services/logger/abstract.logger';
var noop = function () { };
var ɵ0 = noop;
var ProductionLogger = /** @class */ (function (_super) {
    tslib_1.__extends(ProductionLogger, _super);
    function ProductionLogger() {
        var _this = _super.call(this) || this;
        _this._logger = {
            log: noop,
            warn: noop,
            error: function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                console.error.apply(console, params);
            },
        };
        return _this;
    }
    Object.defineProperty(ProductionLogger.prototype, "log", {
        get: function () { return this._logger.log; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductionLogger.prototype, "warn", {
        get: function () { return this._logger.warn; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductionLogger.prototype, "error", {
        get: function () { return this._logger.error; },
        enumerable: true,
        configurable: true
    });
    return ProductionLogger;
}(Logger));
export { ProductionLogger };
export { ɵ0 };
